import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/system';

const MissionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column', // Stack title and cards vertically
  alignItems: 'center',
  gap: '20px',
  padding: '50px',
  [theme.breakpoints.down('sm')]: {
    gap: '10px',
  },
}));

const MissionCardsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '20px',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column', // Stack cards vertically for small screens
    gap: '10px',
  },
}));

const MissionCard = styled(Card)(({ theme }) => ({
  flex: 1,
  padding: '20px',
  textAlign: 'center',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)', // Slight zoom effect on hover
    boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.3)',
  },
}));

const MissionText = styled(Typography)(({ theme }) => ({
  opacity: 0,
  transform: 'translateY(20px)',
  animation: 'fadeInUp 0.5s ease-in-out forwards',
  '@keyframes fadeInUp': {
    '0%': {
      opacity: 0,
      transform: 'translateY(20px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));

function Mission() {
  const missionData = [
    { title: 'Notre mission ', description: 'D’assurer l’analyse chimique, physique, mécanique, géochimique, minéralogique, des échantillons de roches, de sols, des eaux et de minerais provenant des projets publics, privés, des sociétés et des clients divers. D’assurer l’analyse et le contrôle des produits miniers destinés à l’exportation. D’assurer l’analyse, le contrôle de la qualité, la transformation en lingots et poinçonnage exclusif des métaux précieux et bijoux (Or, Argent, etc…). D’assurer la réalisation des essais technologiques. D’assurer les demandes d’expédition à l’Etranger des échantillons de roches et de substances et en délivrer les fiches de contrôle aux fins d’analyse.' },
    { title: 'Notre vision', description: 'La vision du Laboratoire National de la Géologie est de se positionner comme un acteur clé dans le processus de détermination de la qualité et des caractéristiques physiques des minerais sur toute l’étendue du territoire national, dans la Sous-Région ainsi qu’en Afrique en cultivant un partenariat technique, scientifique et commercial avec d’autres Laboratoires qui nous mènera à être le point nodal de l’industrie minière en Guinée et une véritable source de recette pour le Trésor Public.' },
    { title: 'Nos valeurs', description: 'Un personnel professionnel et engagé, à la recherche continue de l’excellence. \n	Une utilisation d’un système intégré qualité – sécurité – environnement (QSE) performant et novateur, avec une technologie de pointe, des équipements modernes, assurant en permanence la capacité du Laboratoire à satisfaire, voire dépasser les exigences, les besoins, les attentes et les perceptions des clients \n Obtenir et maintenir la certification ISO 9001 – 2018 et l’accréditation ISO 17025 – 2017 de notre système qualité par un Organisme International d’Enregistrement aux Normes.'},
  ];

  return (
    <MissionContainer>
      {/* Title */}
      <Typography variant="h4" gutterBottom style={{ textAlign: 'center', fontWeight: 'bold' }}>
        Mission, Vision et Valeurs
      </Typography>

      {/* Cards */}
      <MissionCardsWrapper>
        {missionData.map((item, index) => (
          <MissionCard key={index}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                {item.title}
              </Typography>
              <MissionText variant="body1">{item.description}</MissionText>
            </CardContent>
          </MissionCard>
        ))}
      </MissionCardsWrapper>
    </MissionContainer>
  );
}

export default Mission;